<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1" style="margin: 0px">{{ tajukKad }}</p>
          <!-- <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; flex: 1;">
            <el-button @click="()=>personalExcel()" type="success smaller"><i class="el-icon-document" style="margin-right: 5px;"/>EXCEL</el-button>
          </div> -->
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <!-- <p style="margin-bottom: 0px;">Jenis Akaun : <span style="font-weight: bold;">{{ profileVehicleType | formatProfileVehicleType }}</span></p> -->
          <p style="margin-bottom: 0px; font-weight: bold;">Kuota Subsidi Semasa Bulan : {{ currentMonthLabel }}</p> 
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%; margin-top: 0px;">
            <!-- <p v-if="registerForm.fleetcardSubmittedFlagBoat" style="margin-bottom: 0px;">Jumlah Kuota Bulan (Semasa) : <span style="font-weight: bold;">{{ kenderaanKuotaAsa }} Liter</span></p> -->
            <!-- <p style="font-weight: bold; margin-top: 0px; margin-bottom: 0px; margin-right: 10px;">Carian No. Pendaftaran Kenderaan:</p>
            <el-input
              style="width: 240px;"
              v-model="searchKenderaan">
            </el-input> -->
          </div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%; margin-top: 20px;">
            <!-- <el-button style="padding: 10px 24px;" @click="()=>selectAll()" type="primary" v-if="rayuanless === false">
              Pilih Semua
            </el-button> -->
            <el-button style="padding: 10px 24px;" @click="()=>saveAndNavigate('fleetcard/mulatambahkenderaan')" type="primary" v-if="!locked">
              <i class="el-icon-plus" style="margin-right: 5px;"/> Tambah Kapal/Bot
            </el-button>
          </div>
          <el-table
            :default-sort="{ prop: 'name', order: 'descending' }"
            :data="vehicleArray"
            v-loading.body="loading"
            element-loading-text="Loading"
            @sort-change="sortChange"
            :row-class-name="getRowClassName"
            fit
            highlight-current-row
          >
          <!-- @row-click="rowClick"
            row-class-name="rowClickable" -->
            <el-table-column
              label="No."
              width="50" type="index" :index="indexMethod">
            </el-table-column>
            <el-table-column
              label="#"
              width="50" type="index">
              <template slot-scope="scope">
                <!-- <el-checkbox v-if="!checkboxLoading" :disabled="(scope.row.boatActiveTickedFlag && registerForm.fleetcardSubmittedFlagBoat) || tickedless || getVehicleStatusValue(scope.row) === false" v-model="scope.row.boatActiveTickedFlag" @change="()=>toggleVehicleTicked(scope.row, true)"></el-checkbox> -->
                <el-checkbox v-if="!checkboxLoading" disabled v-model="scope.row.boatActiveTickedFlag" @change="()=>toggleVehicleTicked(scope.row, true)"></el-checkbox>
                <i v-else class="el-icon-loading" style="font-size: 20px; color: var(--primary5-color);"></i>
              </template>
            </el-table-column>
            <!-- <el-table-column label="Tindakan" width="80">
              <template slot-scope="scope">
                <el-button
                  v-if="!locked"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  style="margin-left: 0px;"
                  @click="handleVehicleDelete(scope.$index, scope.row)"
                ></el-button>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="boatNumber"
              label="Nama Bot"
              width="240"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.boatNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Kategori Operasi"
              width="200" type="index">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span class="lh12" style="color: #009900;">
                    {{ scope.row.boatOperationCategoryName ? scope.row.boatOperationCategoryName : '-' }}
                  </span>
                  <!-- <template v-if="getVehicleStatusValue(scope.row) === false">
                    <template v-if="scope.row.vehicleAppealResponse === 'rejected'">
                      <span class="lh12" style="margin-top: 10px; color: #990000;">
                        RAYUAN GAGAL
                        <a class="fileLink" style="font-size: 12px; margin: 0px;" @click="readMoreDialog(scope.row)">Lihat lagi</a>
                      </span>
                    </template>
                    <template v-else>
                      <span class="lh12" style="margin-top: 10px; color: var(--darker-border-color);" v-if="scope.row.vehicleAppealFlag">
                        RAYUAN DALAM PROSES
                      </span>
                      <el-button v-else-if="rayuanless === false" type="primary smaller" @click="()=>viewRayuan(scope.$index, scope.row)" style="margin-left: 5px; margin-top: 10px;">
                        <i class="el-icon-plus"/> Rayuan
                      </el-button>
                    </template>
                  </template> -->
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="vehiclebodytypeId"
              label="Sektor Pengangkutan"
              width="140"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">AWAM</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="boatEngineCapacity"
              label="Kapasiti Enjin (HP)"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.boatEngineCapacity }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="boatMaximumCapacity"
              label="Kapasiti Maksima Kapal/Bot"
              width="140"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.boatMaximumCapacity }}</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="boatRegistrationAgency"
              label="Agensi Bot Didaftarkan"
              width="140"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.boatRegistrationAgency | filterRegistrationAgency }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="vehicleNumber"
              label="No. Pendaftaran Kenderaan"
              width="140"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehiclebodytypeId"
              label="Jenis Badan"
              width="240"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleBodyTypeName ? `${scope.row.vehicleBodyTypeCode ? `(${scope.row.vehicleBodyTypeCode}) - `  : ''}${scope.row.vehicleBodyTypeName}` : scope.row.vehicleBodyTypeCode ? `${scope.row.vehicleBodyTypeCode}` : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehiclemodeltypeId"
              label="Kelas Kegunaan"
              width="240"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleModelTypeName ? `${scope.row.vehicleModelTypeCode ? `(${scope.row.vehicleModelTypeCode}) - `  : ''}${scope.row.vehicleModelTypeName}` : scope.row.vehicleModelTypeCode ? `${scope.row.vehicleModelTypeCode}` : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehicleRoadTaxEndDate"
              label="Tarikh Tamat Cukai Jalan"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleRoadTaxEndDate | formatDate }}</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="boatQuotaBase"
              label="Kuota Asas (Liter)"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span>{{ scope.row.boatQuotaBase | formatNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="vehicleQuotaFinal"
              label="Kuota Semasa (Liter)"
              width="180"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span>-</span>
                </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="Ulasan"
      :visible.sync="userReadMore"
      :before-close="resetForm">
      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center;">
        <span style="margin-bottom: 5px;">{{ currentCompanyName }}</span>
        <span style="font-weight: bold; font-size: 24px; color: #000;">{{ currentVehicleNumber }}</span>
        <span class="readMoreRemarks">{{ currentRemarks }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Tutup</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  activeTickFleetCardVehicles,
  personalExcelFleetCardVehicles
} from "@/api/myboat/myboatFleetCardVehicles";
import moment from 'moment'
export default {
  name: 'vehicle-new',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      currentMonth: null,
      userReadMore: false,
      currentCompanyName: '',
      currentVehicleNumber: '',
      currentRemarks: '',
      checkboxLoading: false,
    }
  },
  methods: {
    resetForm() {
      this.userReadMore = false
      this.currentCompanyName = ''
      this.currentVehicleNumber = ''
      this.currentRemarks = ''
    },
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    },
    rowClick(row, column) {
      // if (column.label !== '#' && column.label !== 'Tindakan') {
      //   row.boatActiveTickedFlag = row.boatActiveTickedFlag === true ? false : true
      // }
    },
    async personalExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let resp = await personalExcelFleetCardVehicles(this.$store.state.app.branchSelected, this.registerForm.branchId)
        var link = document.createElement('a')
        link.href = URL.createObjectURL(new Blob([resp]))
        var fileName = `Senarai Bot-${moment().unix()}.xlsx`
        link.download = fileName
        link.click()
      } catch (err) {
        console.log("download excel", err)
      }
      loading.close()
    },
    async selectAll() {
      this.checkboxLoading = true
      const allChecked = this.vehicleArray.every((item) => {
        const firstFlag = this.getVehicleStatusValue(item) === false ? true : false
        const secondFlag = !firstFlag ? item.boatActiveTickedFlag === true ? true : false : true
        return secondFlag
      })
      if (allChecked === true && this.registerForm.fleetcardSubmittedFlagBoat) {
        this.checkboxLoading = false
        return
      }
      await this.vehicleArray.forEach(async (item) => {
        if (this.getVehicleStatusValue(item) === true) {
          item.boatActiveTickedFlag = !allChecked;
          try {
            await this.toggleVehicleTicked(item, false);
          } catch (err) {
            console.log("err", err)
          }
        }
      })
      if (!allChecked) {
        this.$message({
          message: 'Kenderaan telah diaktifkan',
          type: 'success'
        })
      } else {
        this.$message({
          message: 'Kenderaan telah dinyahaktifkan',
          type: 'success'
        })
      }
      this.checkboxLoading = false
    },
    async toggleVehicleTicked(row, promptMessage) {
      if (promptMessage) {
        this.checkboxLoading = true
      }
      try {
        const awamDiffer = row.vehiclebodytypeId && row.vehiclebodytypeId.bodytypeSector === 'awam' && (this.profileVehicleType === 'barangan' || this.profileVehicleType === '') ? true : false
        const baranganDiffer = row.vehiclebodytypeId && row.vehiclebodytypeId.bodytypeSector === 'barangan' && (this.profileVehicleType === 'awam' || this.profileVehicleType === '') ? true : false
        const payload = {
          boatActiveTickedFlag: row.boatActiveTickedFlag
        }
        await activeTickFleetCardVehicles(this.$store.state.app.branchSelected, row._id, payload)
        if (row.boatActiveTickedFlag) {
          if (promptMessage) {
            this.$message({
              message: 'Kenderaan telah diaktifkan',
              type: 'success'
            })
            this.checkboxLoading = false
          }

          // If Awam & Barangan are separate
          if ((awamDiffer || baranganDiffer) && this.registerForm.fleetcardSubmittedFlagBoat) {
            // Call parent method to fetch selection oil company array
            // this.$emit('fetchSelectionOilCompanyArray', row._id);
            this.$emit('refreshProfileVehicleType');
          }
        } else {
          if (promptMessage) {
            this.$message({
              message: 'Kenderaan telah dinyahaktifkan',
              type: 'success'
            })
            this.checkboxLoading = false
          }
        }
        // }
      } catch (err) {
        if (promptMessage) {
          this.checkboxLoading = false
        }
        console.log("err", err)
      }
    },
    getVehicleStatusLabel(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const boatActiveTickedFlag = row.boatActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return "RAYUAN LULUS"
      }
      if (!vehicleValidBodyFlag) {
        return "JENIS BADAN TIDAK LAYAK"
      }
      if (!vehicleValidModelFlag) {
        return "KELAS KEGUNAAN TIDAK LAYAK"
      }
      if (vehicleRoadTaxPassedFlag) {
        return "TAMAT CUKAI JALAN"
      }
      return "KENDERAAN LAYAK"
    },
    getVehicleStatusValue(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const boatActiveTickedFlag = row.boatActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return true
      }
      if (!vehicleValidBodyFlag || !vehicleValidModelFlag || vehicleRoadTaxPassedFlag) {
        return false
      }
      return true
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/mybps/${webpage}`)
    },
    getRowClassName({ row, rowIndex }) {
      if (row.boatActiveTickedFlag) {
        return 'submitted-ticked-row'
      }
      return ''
    },
    readMoreDialog(row) {
      this.userReadMore = true
      if (this.registerForm) {
        this.currentCompanyName = this.registerForm.userGeneralName ? this.registerForm.userGeneralName : this.registerForm.userCompanyName
      }
      this.currentVehicleNumber = row.vehicleNumber
      this.currentRemarks = row.vehicleAppealRemarks
    },
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    vehicleArray: {
      type: Array
    },
    searchKenderaan: {
      type: String
    },
    handleVehicleDelete: {
      type: Function
    },
    saveAndNavigate: {
      type: Function
    },
    viewRayuan: {
      type: Function
    },
    profileVehicleType: {
      type: String
    },
    locked: {
      type: Boolean
    },
    tickedless: {
      type: Boolean
    },
    rayuanless: {
      type: Boolean
    },
    registerForm: {
      type: Object
    },
    revealBaranganQuota: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  filters: {
    formatProfileVehicleType(val) {
      switch (val) {
        case 'awambarangan': return 'AWAM & BARANGAN'
        case 'awam': return 'AWAM'
        case 'barangan': return 'BARANGAN'
        default: return '-'
      }
    },
    filterRegistrationAgency(val) {
      switch (val) {
        case 'jlm': return 'Jabatan Laut Malaysia (JLM)'
        case 'jpds': return 'Jabatan Pelabuhan dan Dermaga Sabah (JPDS)'
        case 'lss': return 'Lembaga Sungai Sarawak (LSS)'
        default: return '-'
      }
    },
    formatDateTime(val) {
      if (val !== undefined) {
        return moment.unix(Number(val)).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    formatDate(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    },
  },
  computed: {
    kenderaanKuotaAsa() {
      return Number(this.vehicleArray.filter(item => item.boatActiveTickedFlag).reduce((acc, item) => {
        const value = Number(item.vehicleQuotaFinal) ? Number(item.vehicleQuotaFinal) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    kenderaanKuotaSemasa() {
      return Number(this.vehicleArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaCurrent) ? Number(item.vehicleQuotaCurrent) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    currentMonthLabel() {
      switch (this.currentMonth) {
        case '01': return 'JANUARI'
        case '02': return 'FEBRUARI'
        case '03': return 'MAC'
        case '04': return 'APRIL'
        case '05': return 'MEI'
        case '06': return 'JUN'
        case '07': return 'JULAI'
        case '08': return 'OGOS'
        case '09': return 'SEPTEMBER'
        case '10': return 'OKTOBER'
        case '11': return 'NOVEMBER'
        case '12': return 'DISEMBER'
      }
    }
  },
  mounted() {
    this.currentMonth = moment().format('MM')
  }
}
</script>

<style scoped>
.submitted-ticked-row {
  background-color: #ffe6e6 !important;
}

.submitted-ticked-row:hover {
  background-color: #ffcccc !important;
}
</style>


// WEBPACK FOOTER //
// src/views/myboat/components/VehicleNewBoat.vue